import * as React from 'react';
import { useNavigate } from "react-router-dom";
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

const Item = styled(Button)(({ theme }) => ({
    width: '20vw',
    height: '16vmin',
    fontSize: '4vmin'
}));

const BoxItem = styled(Box)(({ theme }) => ({
    position: 'absolute',
    width: '100%',
    height: '100%',
    backgroundImage: 'linear-gradient(195deg, rgb(66, 66, 74), rgb(25, 25, 25))',
}));

export default function Home() {    
    const navigate = useNavigate();

    const linkHandler = (to) => {
        navigate(to)
    }

    return (
        <BoxItem>
            <Stack spacing={{ xs: 1, sm: 2 }} direction="row" flexWrap="wrap"
                justifyContent="center"
                alignItems="center"
                sx={{ width: '100%', height: '100%' }}
            >
                <Item variant='contained' onClick={() => linkHandler('/dashboard')}>대시보드</Item>
                {/* <Item variant='contained' onClick={() => linkHandler('/gis')}>GIS</Item> */}
                <Item variant='contained' onClick={() => linkHandler('/gis/gisView')}>GIS</Item>
                <Item variant='contained' onClick={() => linkHandler('/module')}>모듈</Item>
                <Item variant='contained' onClick={() => linkHandler('/Link2SelectView')}>교통량정보</Item>
                
            </Stack>
            <Typography sx={{position:'absolute', left:0, top:0, m:1}}>* 월컨트롤러(10400x1800), 대시보드(1907x1800), GIS(3293x1800), 데이터 모듈(5200x1800)</Typography>
        </BoxItem>
    );
}